import React from 'react';

export const TopBanner: React.FC = () => {
  return (
    <div className="top-banner text-white py-2 sm:py-2.5">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-12">
        <div className="flex items-center justify-between text-xs font-medium">
          <div className="flex items-center space-x-2">
            <div className="w-1.5 h-1.5 bg-white rounded-full animate-pulse opacity-80"></div>
            <span className="tracking-wide uppercase">Live Updates</span>
          </div>
          <span className="hidden sm:block opacity-75">
            {new Date().toLocaleDateString('en-US', {
              weekday: 'long',
              year: 'numeric',
              month: 'long',
              day: 'numeric',
            })}
          </span>
        </div>
      </div>
    </div>
  );
};
